import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Menu, X, User } from "lucide-react";
import { RariumWordmark, RariumMark } from "./Logo";
import { useLanguage } from "../context/LanguageContext";

const NAV = [
  { to: "/browse", label: "Aste" },
  { to: "/categories", label: "Categorie" },
  { to: "/sell", label: "Vendi" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "Il nostro metodo" },
];

export default function Header() {
  const { user, logout } = useAuth();
  const { language, setLanguage, t } = useLanguage();
  const [open, setOpen] = React.useState(false);
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-stone-50/85 backdrop-blur-xl border-b border-stone-200">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        <Link to="/" data-testid="brand-logo" className="inline-flex items-center gap-3">
          <RariumMark className="h-9 w-9" />
          <RariumWordmark className="h-6 hidden sm:block" />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map(n => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace("/", "")}`}
              className="text-sm underline-hover text-stone-800"
            >{t(n.label)}</Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <select
            aria-label={t("Lingua")}
            data-testid="language-select"
            value={language}
            onChange={(event) => setLanguage(event.target.value)}
            className="min-h-12 border border-stone-300 bg-transparent px-2 text-xs uppercase tracking-widest text-stone-800"
          >
            <option value="it">Italiano</option>
            <option value="en">English</option>
          </select>
          {user && user !== false ? (
            <div className="hidden md:flex items-center gap-4">
              {user.role === "admin" && (
                <Link
                  to="/admin"
                  data-testid="admin-link"
                  className="text-[10px] uppercase tracking-widest font-semibold bg-[#8C3A3A] text-stone-50 px-3 py-1"
                >Admin</Link>
              )}
              <Link
                to="/dashboard"
                data-testid="dashboard-link"
                className="text-sm underline-hover"
              >
                <span className="inline-flex items-center gap-2"><User size={14} />{user.name || user.email}</span>
              </Link>
              <Link
                to="/profile"
                data-testid="profile-link"
                className="text-sm underline-hover text-stone-600"
              >{t("Profilo")}</Link>
              <button
                onClick={async () => { await logout(); nav("/"); }}
                data-testid="logout-btn"
                className="text-sm underline-hover text-stone-600"
              >{t("Esci")}</button>
            </div>
          ) : (
            <div className="hidden md:flex items-center gap-4">
              <Link to="/login" data-testid="login-link" className="text-sm underline-hover">{t("Accedi")}</Link>
              <Link
                to="/register"
                data-testid="register-link"
                className="text-xs uppercase tracking-widest font-semibold bg-stone-900 text-stone-50 hover:bg-[#8C3A3A] px-5 py-3 transition-colors"
              >{t("Registrati")}</Link>
            </div>
          )}
          <button
            onClick={() => setOpen(v => !v)}
            className="md:hidden p-2"
            data-testid="mobile-menu-btn"
            aria-label={t("Menu")}
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-stone-200 bg-stone-50">
          <div className="p-6 flex flex-col gap-4">
            {NAV.map(n => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} data-testid={`mnav-${n.to.replace("/", "")}`} className="text-base">{t(n.label)}</Link>
            ))}
            <div className="rule pt-4 flex flex-col gap-3">
              {user && user !== false ? (
                <>
                  <Link to="/dashboard" onClick={() => setOpen(false)} data-testid="mdashboard-link">{t("Il tuo account")}</Link>
                  {user.role === "admin" && (
                    <Link to="/admin" onClick={() => setOpen(false)} data-testid="madmin-link" className="text-[#8C3A3A] font-semibold">Admin</Link>
                  )}
                  <button onClick={async () => { await logout(); setOpen(false); nav("/"); }} data-testid="mlogout-btn" className="text-left">{t("Esci")}</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setOpen(false)} data-testid="mlogin-link">{t("Accedi")}</Link>
                  <Link to="/register" onClick={() => setOpen(false)} data-testid="mregister-link">{t("Registrati")}</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
